import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    isSettings: false,
    actualSkin: {
        color: "#0cc",
        background: "rgba(0, 204, 204, .4)",
        wall: "rgba(0, 204, 204, .15)"
    },
    skins: [
        {
            color: "#0cc",
            background: "rgba(0, 204, 204, .4)",
            wall: "rgba(0, 204, 204, .15",
            isActive: true
        },
        {
            color: "#0c0",
            background: "rgba(0, 204, 0, .4)",
            wall: "rgba(0, 204, 0, .15",
            isActive: false
        },
        {
            color: "#f60",
            background: "rgba(255, 102, 0, .4)",
            wall: "rgba(255, 102, 0, .15)",
            isActive: false
        },
        {
            color: "#f0f",
            background: "rgba(255, 0, 255, .4)",
            wall: "rgba(255, 0, 255, .15)",
            isActive: false
        },
        {
            color: "#e00",
            background: "rgba(204, 0, 0, .2)",
            wall: "rgba(204, 0, 0, .15)"
        }
    ]
}

// mutations
const mutations = {
    isSettings(state, val) {
        state.isSettings = val;
    },
    actualSkin(state, val) {
        state.actualSkin.color = val.color;
        state.actualSkin.background = val.background;
        state.actualSkin.wall = val.wall;
        // Toggle the actual active skin
        state.skins.map(function(obj) {
            if (obj === val) {
                obj.isActive = true;
            } else {
                obj.isActive = false;
            }
        });
    }
}

const getters = {
    isSettings(state) {
        return state.isSettings
    },
    actualSkin(state) {
        return state.actualSkin
    },
    skins(state) {
        return state.skins
    }
}

export default {
    namespaced: true,
    state,
    getters,
    //    actions,
    mutations
}